<template>
  <div class="dashboard-container">
    <div class="body">
      <span class="detail">排课详情</span>
      <span class="el-icon-circle-close icon_goback" @click="fanhui"></span>
    </div>
    <div class="app-container">
      <div class="filter-container">
        <div class="header">

            <span style="color: red; position: absolute;  left: 34px;  margin-top: 4px;  font-size: 20px;  font-weight: 900;" v-if="isAudition === 1">试听课</span>
          <!-- <el-button
            style="margin-right: 20px;"
            type="text"
            @click="goBack"
            icon="el-icon-back"
            >返回</el-button> -->
          <!-- <el-button style="margin-right: 20px;" type="text" @click="oneTouch"
            icon="el-icon-switch-button">一键结课</el-button> -->
          <!-- <el-button style="margin-right: 20px;" v-if="courseScheduleData.classEnding === 2" type="text"
            @click="endCourse" icon="el-icon-switch-button">结课</el-button>
          <el-button style="margin-right: 20px;" v-if="courseScheduleData.classEnding === 1" type="text"
            @click="cancelEndCourse" icon="el-icon-close">取消结课</el-button> -->
          <el-button :disabled="isShow" style="margin-right: 20px;" type="text" icon="el-icon-edit-outline"  @click="cancelCourse">修改课节</el-button>
          <el-button :disabled="isShow" style="margin-right: 20px;" type="text" icon="el-icon-edit" @click="batchChange">批量修改</el-button>
          <el-button :disabled="isShow"  style="margin-right: 20px;" type="text " icon="el-icon-delete" @click="delClass">删除课节</el-button>
          <el-button :disabled="isShow"  type="text " icon="el-icon-s-grid" @click="batchDels" style="margin-right: 20px;">批量删除</el-button>
          <el-button v-if="isShow1"  style="margin-right: 20px;" type="text" icon="el-icon-edit" @click="handleRevokes('同步')">同步排课</el-button>
          <!-- <el-button v-if="isShow1"  style="margin-right: 20px;" type="text" icon="el-icon-edit" @click="handleRevokes('撤销')">撤销排课</el-button> -->
        </div>
        <div style="background-color: white;padding-top:20px;height:50px;">
          <el-form :inline="true" left>
            <el-row>
              <el-col>
                <el-form-item class="course_post">
                  <!-- class="courseClass" -->
                  <span slot="label">
                    <span class="formLabel">课程:</span>
                  </span>
                  <span class="form_text">{{ courseScheduleData.courseName }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">日期：</span>
                  </span>
                  <span class="form_text">{{ courseScheduleData.courseDate }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">开始时间：</span>
                  </span>
                  <span class="form_text">{{ courseScheduleData.courseTimeOn }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">结束时间：</span>
                  </span>
                  <span class="form_text">{{ courseScheduleData.courseEndTime }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">任课老师：</span>
                  </span>
                  <span class="form_text">{{ courseScheduleData.teacherName }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">排课状态：</span>
                  </span>
                  <span class="form_text">{{ courseStatus }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">同步状态：</span>
                  </span>
                  <span class="form_text">{{  isPreScheduled  }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">班型：</span>
                  </span>
                  <span class="form_text">{{  typeState1  }}</span>
                </el-form-item>
                <el-form-item class="course_post">
                  <span slot="label">
                    <span class="formLabel">上课人员类型：</span>
                  </span>
                  <span class="form_text">{{  typeState  }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="footer">
        <div class="sub">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="学员:" style="float: left; margin-left: 10px; margin-top: 10px">
              <el-input size="samll" v-model="name" clearable placeholder="请输入姓名查询" @clear="inputListener"
                @keyup.enter.native="handleSearch"></el-input>
            </el-form-item>
            <!-- <el-form-item style="margin-top: 10px">
              <el-button v-if="courseScheduleData.classEnding === 2" type="primary" @click="saveSignin(1)">签到</el-button>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="stu">
          <el-table :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" border ref="multipleTable" :data="studentList" tooltip-effect="dark" style="width: 100%; margin-top: -8px"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="realname" label="姓名">
              <template slot-scope="scope">
                <!-- <router-link :to="'/student-detail/' + scope.row.id" class="name-link"
                  @click="highlightRow(scope.$index)">
                  {{ scope.row.realname }}
                </router-link> -->
                <span @click="btnNameStu(scope.row)" class="name_color">{{ scope.row.realname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.sex === 1">男</span>
                <span v-else-if="scope.row.sex === 2">女</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeStr" label="年级"> </el-table-column>
            <el-table-column prop="educationType" label="上课方式">
              <!-- <template slot-scope="scope">
              <span>{{ scope.row.educationType==2 ? "网课": "上门"  }}</span>
            </template> -->
              <template slot-scope="scope">
                <span v-if="scope.row.educationType === 1">网课</span>
                <span v-if="scope.row.educationType === 2">上门</span>
                <span v-if="scope.row.educationType === 3">门店</span>
                <!-- <span v-else>上门</span> -->
              </template>
            </el-table-column>
            <el-table-column prop="telephone" label="联系电话">
            </el-table-column>
            <!-- <el-table-column prop="teacheName" label="任课老师">
            </el-table-column> -->
            <el-table-column label="结课状态">
              <template slot-scope="scope">
                <span>{{ scope.row.classEnding === 1 ? "已结课" : "未结课" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="家庭住址"> </el-table-column>
            <el-table-column prop="prepareAddress" label="备用住址" >
              <template slot-scope="scope" >
                <!-- <span @click="handleViewTo(scope.row)" style="color: #2da0e5;">查看</span> -->
                 <div v-for="(itms,index) in scope.row.prepareAddress" :key="index" >
                    <div style="margin-bottom: 10px;">{{ index + 1}}：{{ itms.address }}</div>
                 </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 点击修改课节弹窗 -->
        <el-dialog append-to-body id="bb" title="修改信息:" :visible.sync="showDialog" :width="'55%'" class="custom-dialog">
          <el-form ref="ruleForm" :model="courseScheduleData" :rules="rules">
            <!-- 其他表单项... -->

            <el-form-item label="课1程" label-width="100px" prop="courseName">
              <el-input autocomplete="off" :disabled="true" type="text"
                v-model="courseScheduleData.courseName"></el-input>
            </el-form-item>
            <el-form-item label="日期" label-width="100px" prop="courseDate">
              <el-date-picker value-format="yyyy-MM-dd" v-model="courseScheduleData.courseDate" type="date"
                placeholder="选择日期" style="width: 100%"  :disabled="courseScheduleData.classEnding === 1">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开始时间" label-width="100px" prop="courseTimeOn" :disabled="courseScheduleData.classEnding === 1">
              <mz-time-select :dddd="courseScheduleData.classEnding === 1 ? true : false" @clean="clean" :timePeriod="'start'" :childPlaceholder="'开始时间'"
                @startTimeSelect="startTimeSelect" v-model="courseScheduleData.courseTimeOn"
                :valueTime="courseScheduleData.courseTimeOn" :style="{ pointerEvents: courseScheduleData.classEnding === 1 ? 'none' : '',
                 background: courseScheduleData.classEnding === 1 ?  '#E4E7ED' : '' }"></mz-time-select>
              <!-- <el-time-select v-model="courseScheduleData.courseTimeOn" style="width: 100%" :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '18:30'
              }">
              </el-time-select> -->
            </el-form-item>
            <el-form-item label="结束时间" label-width="100px" prop="courseEndTime" :disabled="courseScheduleData.classEnding === 1">
              <mz-time-select @clean="clean" :timePeriod="'end'" :childPlaceholder="'结束时间'"
                @startTimeSelect="startTimeSelect" v-model="courseScheduleData.courseEndTime"
                :valueTime="courseScheduleData.courseEndTime" :dddd="courseScheduleData.classEnding === 1 ? true : false" :style="{ pointerEvents: courseScheduleData.classEnding === 1 ? 'none' : '',
                background: courseScheduleData.classEnding === 1 ?  '#E4E7ED' : ''  }"></mz-time-select>
              <!-- <el-time-select v-model="courseScheduleData.courseEndTime" style="width: 100%" :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '18:30'
              }">
              </el-time-select> -->
            </el-form-item>
            <el-form-item label="老师" label-width="100px" prop="teacherId">
              <!-- <el-select @visible-change="techerBtnList" v-model="courseScheduleData.teacherId" placeholder="请选择教师"
                style="width: 100%"
                v-if="courseScheduleData.courseDate && courseScheduleData.courseTimeOn && courseScheduleData.courseEndTime"
                clearable :disabled="courseScheduleData.classEnding === 1" >
                <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                  :label="teacher.realname" :value="teacher.id">
                </el-option>
              </el-select> -->
              <el-select @visible-change="techerBtnList" v-model="courseScheduleData.teacherId" placeholder="请选择教师"
                style="width: 100%"
                v-if="courseScheduleData.courseDate && courseScheduleData.courseTimeOn && courseScheduleData.courseEndTime"
                clearable disabled>
                <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
                  :label="teacher.realname" :value="teacher.id">
                </el-option>
              </el-select>
              <el-select v-else placeholder="请选择教师" disabled style="width: 100%;"
                v-model="courseScheduleData.teacherId"></el-select>
            </el-form-item>
            <el-form-item label="上课方式" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="courseScheduleData.educationType" :disabled="courseScheduleData.classEnding === 1">
                <el-radio :label="1">网课</el-radio>
                <el-radio :label="2">上门</el-radio>
                <el-radio :label="3">门店</el-radio>
              </el-radio-group>
            </el-form-item>

           <el-form-item   label="是否试听课"   label-width="100px"   style="text-align: left"  >
              <el-radio-group v-model="isAudition">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="班型" label-width="100px">
                <div v-if="!ClassType" style="position: absolute; color: #F56C6C; width: 1px; height: 1px;z-index: 111111; margin-left: -52px;">*</div>
                <el-select  style="width: 100%" v-model="ClassType" placeholder="请选择"  filterable  >
                  <el-option   style="margin-left: 10px"   v-for="item in classPersonTypeList1"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="上课人员类型" label-width="100px" >
                <el-select  style="width: 100%" v-model="classPersonType1" placeholder="请选择"  filterable @focus="handleChanges"  >
                  <el-option   style="margin-left: 10px"   v-for="item in classPersonTypeList"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="路补" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="roadFilling" :disabled="courseScheduleData.classEnding === 1" style="display: flex;padding-top: 14px;">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
                <div v-if="roadFilling == 1" style="width: 50%;margin-top: -11px;">
                  <el-input v-model="roadFillingInput" :disabled="courseScheduleData.classEnding === 1" clearable  :maxlength="9" @input="handleInput" placeholder="输入金额"></el-input>
                </div>
              </el-radio-group>
            </el-form-item>


            <!--  -->
            <el-form-item label="五次课" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="courseScheduleData.isFive" :disabled="courseScheduleData.classEnding === 1">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="首次课" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="courseScheduleData.isFirst" :disabled="courseScheduleData.classEnding === 1">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showDialog = false, roadFilling = 2 , roadFillingInput ='', classPersonType1 ='' " size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="submitForm333(ruleForm)">保存</el-button>
          </div>
        </el-dialog>

        <!-- 点击签到弹窗 -->
        <el-dialog id="ff" append-to-body title="到课情况" :visible.sync="dialog" width="40%" class="custom-dialog">
          <el-radio-group v-model="signin">
            <el-radio :label="1">签到</el-radio>
          </el-radio-group>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialog = false">取消</el-button>
            <el-button size="small" type="primary" @click="saveSignin(2)">提交</el-button>
          </span>
        </el-dialog>
        <!-- 一键节课弹窗 -->
        <el-dialog title="提示" append-to-body :visible.sync="dialogVisibles" width="30%">
          <el-date-picker v-model="courseDate1" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibles = false">取 消</el-button>
            <el-button type="primary" @click="okTouch">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 点击学生姓名弹窗 -->
        <el-dialog class="stu_name" :visible.sync="popupVisible" append-to-body width="70%">
          <schedu-detadia :id="stuNameId" :scheduleId="batchList.scheduleId" v-if="popupVisible"></schedu-detadia>
        </el-dialog>
        <!--批量修改弹窗-->
        <el-dialog append-to-body id="cc" title="修改批量排课" :visible.sync="dialogVisible1" :width="'55%'">
          <el-form>
            <el-form-item label="日期" label-width="100px">
              <el-date-picker type="date" placeholder="选择日期" style="width: 100%;" value-format="yyyy-MM-dd"
                v-model="batchList.courseDate">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开始时间" label-width="100px" prop="startTime">
              <mz-time-select @clean="clean" :timePeriod="'start1'" :childPlaceholder="'开始时间'"
                @startTimeSelect="startTimeSelect" v-model="batchList.courseTimeOn"
                :valueTime="batchList.courseTimeOn"></mz-time-select>
            </el-form-item>
            <el-form-item label="结束时间" label-width="100px" prop="courseEndTime">
              <mz-time-select @clean="clean" :timePeriod="'end1'" :childPlaceholder="'结束时间'"
                @startTimeSelect="startTimeSelect" v-model="batchList.courseEndTime"
                :valueTime="batchList.courseEndTime"></mz-time-select>
            </el-form-item>
            <!-- <el-form-item label="开始时间" label-width="80px" prop="startTime">
              <el-time-select v-model="batchList.courseTimeOn" style="width: 100%;" :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '23:30'
              }">
              </el-time-select>
            </el-form-item>
            <el-form-item label="结束时间" label-width="80px" prop="endTime">
              <el-time-select v-model="batchList.courseEndTime" style="width: 100%;" :picker-options="{
                start: '06:00',
                step: '00:15',
                end: '23:30'
              }">
              </el-time-select>
            </el-form-item> -->
            <el-form-item label="老师" label-width="100px">
              <!-- @visible-change="batchtecherBtnList"
              v-if="batchList.courseDate && batchList.courseTimeOn && batchList.courseEndTime" -->
              <el-select placeholder="请选择教师" :disabled="true" style="width: 100%;" v-model="batchList.teacherId" clearable>
                <el-option style="margin-left: 10px;" v-for="teacher in teachers" :key="teacher.id"
                  :label="teacher.realname" :value="teacher.id">
                </el-option>
              </el-select>
              <!-- <el-select v-else placeholder="请选择教师" disabled style="width: 100%;" v-model="batchList.teacherId"></el-select> -->
            </el-form-item>
            <el-form-item label="学员" label-width="100px">
              <el-select style="width: 100%;" :disabled="true" v-model="batchList.studentIdd" multiple placeholder="请选择">
                <el-option style="margin-left: 10px;" v-for="item in studentList" :key="item.id" :label="item.realname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上课方式" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="batchList.educationType" :disabled="true">
                <el-radio :label="1">网课</el-radio>
                <el-radio :label="2">线下</el-radio>
                <el-radio :label="3">门店</el-radio>
              </el-radio-group>
            </el-form-item>


            <el-form-item label="是否试听课" label-width="100px" style="text-align: left;">
              <el-radio-group v-model="isAudition" :disabled="true">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="班型" label-width="100px">
                <div v-if="!ClassType" style="position: absolute; color: #F56C6C; width: 1px; height: 1px;z-index: 111111; margin-left: -52px;">*</div>
                <el-select  style="width: 100%" v-model="ClassType" placeholder="请选择"  filterable  >
                  <el-option   style="margin-left: 10px"   v-for="item in classPersonTypeList1"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="上课人员类型" label-width="100px" >
                <el-select  style="width: 100%" v-model="classPersonType" placeholder="请选择"  filterable  @focus="handleChanges">
                  <el-option   style="margin-left: 10px"   v-for="item in classPersonTypeList"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="循环排课" label-width="100px" >
              <el-select placeholder="请选择循环排课类型"  :disabled="true" style="width: 100%;" clearable @change="handleClick"
                v-model="batchList.relativeTime">
                <el-option style="margin-left: 10px;" v-for="item in relativeTimes" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="batchList.relativeTime == 3" label="星期选择" label-width="100px">
              <el-checkbox-group v-model="batchList.checkList" style="text-align: left;" :disabled="true">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="排课次数" style="text-align: left;" label-width="100px" v-if="batchList.relativeTime != 4">
              <el-input-number :disabled="true" v-model="batchList.num" @change="handleChange" :min="1" :max="99999"
                label="描述文字"></el-input-number>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false, classPersonType = ''" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="submitForm222">保存</el-button>
          </div>
        </el-dialog>

        <el-dialog append-to-body title="请输入删除原因" :visible.sync="dialogdeleteCause" :width="'55%'" :before-close="handleclick2">

          <div>
            <el-input :autosize="{ minRows: 6, maxRows: 6 }" type="textarea" placeholder="请输入删除原因"  v-model="deleteCause"  maxlength="200"  show-word-limit > </el-input>
          </div>


          <div slot="footer" class="dialog-footer">
            <el-button @click="handleclick2" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="handleclick1">保存</el-button>
          </div>

        </el-dialog>


        <el-dialog append-to-body  title="修改原因" :visible.sync="showTT" :width="'55%'">
          <el-form label-width="50px">
            <el-form-item label="原因">
              <el-input placeholder="请输入" maxlength="200" :autosize="{ minRows: 5, maxRows: 5}" show-word-limit	 type="textarea"  v-model="updateCause"></el-input
            ></el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showTT = false,updateCause = ''">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog append-to-body  title="修改原因" :visible.sync="showTTT" :width="'55%'">
          <el-form label-width="50px">
            <el-form-item label="原因">
              <el-input placeholder="请输入" maxlength="200" :autosize="{ minRows: 5, maxRows: 5}" show-word-limit	 type="textarea"  v-model="updateCause1"></el-input
            ></el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showTTT = false,updateCause1 = ''">取 消</el-button>
            <el-button type="primary" @click="submitForm1">确 定</el-button>
          </span>
        </el-dialog>



      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import { EventBus } from "../../assets/js/event";
import apiBaseUrl from "../../config/api";
import scheduDetadia from "./scheduDetadia.vue"
import { EventBus } from "../assets/js/event";

import loadingUtils from "../utils/loading";
export default {
  components: {
    scheduDetadia
  },
  data () {
    return {

      isShowListening: false, // 是否显示试听课
      
      ClassType:'',
      classPersonTypeList1:[ ],
      classPersonType:'',
      classPersonType1:'',
      classPersonTypeList:[
        // { id: 1, name: '孩子'},
        // { id: 2, name: '孩子和父亲'},
        // { id: 3, name: '孩子和母亲'},
        // { id: 4, name: '父亲'},
        // { id: 5, name: '母亲'},
        // { id: 6, name: '父亲和母亲'},
        // { id: 7, name: '孩子、父亲、母亲'},
      ],
      updateCause:'',
      showTT:false,
      updateCause1:'',
      showTTT:false,
      dialogdeleteCause: false,
      id: "",
      courseDate1: "",//一键结课日期
      dialogVisibles: false,//一键节课弹窗
      dialogVisible1: false, //控制批量修改显示隐藏
      typeState:'',
      typeState1:'',
      //批量修改
      relativeTimes: [
        {
          value: "1",
          label: "每天"
        },
        {
          value: "2",
          label: "每周"
        },
        {
          value: "3",
          label: "自定义"
        },
        {
          value: "4",
          label: "无"
        }
      ],
      studentList: [], //获取所有学生
      ListDataLngLat: [],

      selectedTeacher: [], //所有老师
      batchList: {
        courseId: "",
        selectDate: "",
        numberOfClassDeductions: "",
        // recurrentScheduling: "",
        checkList: [], //选中的周几数组
        teacherId: "", //老师
        educationType: 1, //网课线下标识
        relativeTime: "4",
        courseDate: "", //日期
        courseTimeOn: "", //开始时间
        courseEndTime: "", //结束时间
        num: "1", //排课次数
        // studentIds: [], //选中的学生
        scheduleId: "",
        batchNo: "",
        studentId: [],
        studentIdd: [] //选中学生id集合
      },
      dialog: false, //签到
      // signin: "",
      highlightedIndex: -1, // 保存高亮的行索引
      popupVisible: false,
      selectedStudents: [], // 初始化选中的学员数组
      teachers: [],
      batchNo: "", //批量删除标识
      signin: true, // 初始化签到状态
      showDialog: false, //修改详情
      name: "", //查询学生姓名
      courseEnded: false, // 当前课程是否已结课
      teacher_id: "", // 初始化teacher_id
      courseScheduleData: {
        courseName: null,
        scheduleId: null,
        teacherId: null,
        courseDate: null,
        courseTimeOn: null,
        courseEndTime: null,
        teacherName: null,
        classEnding: null,
        educationType: null,
        isFive:2,
        isFirst:2,
      },
      ruleForm: {
        // 表单项的初始值
        courseDate: "", //日期
        courseTimeOn: "", //开始时间
        courseEndTime: "", //结束时间
        selectedTeacher: null //教师
      },
      rules: {
        // 校验规则
        courseDate: [
          { required: true, message: "日期不能为空", trigger: "change" }
        ],
        courseTimeOn: [
          { required: true, message: "开始时间不能为空", trigger: "change" }
        ],
        courseEndTime: [
          { required: true, message: "结束时间不能为空", trigger: "change" }
        ],
        teacherId: [
          { required: true, message: "请选择老师", trigger: "change" }
        ]
      },
      btnClickAllow: false,
      stuNameId: '',
      deleteCause:"",
      roadFilling: 2,
      roadFillingInput: "",
      isShow:false,
      isShow1:false,
      scheduleIdIDS:'',
      courseStatus:'',
      isPreScheduled:'',


      isAudition: 0,

    };
  },
  props: {
    childScheduleId: {
      type: Number,
      default: "",
    }
  },
  async created () {
    //跳转路由携带参数
    await this.fetchTeachers();
    await this.openDialog(this.childScheduleId);
  },

  methods: {
    oseDialog(){
      this.studentFilesVisibleIS = false
    },
    handleViewTo(row){
      if(row.ListDataLngLat){
        this.ListDataLngLat = row.ListDataLngLat
        this.studentFilesVisibleIS = true
      }else{
        this.$message({ message:'暂无数据~', type:'warning' })
      }
    },
    handleRevokes(type){
        let data = { scheduleId: this.scheduleIdIDS }
        axios.put(`${apiBaseUrl}/${type === '同步' ? 'preScheduled/syncOne' : 'preScheduled/quashOne' }`, data, { headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
          if(res.data.code === 200){
              this.$message({  message: res.data.message, type: "success", });
              this.openDialog()
            }else{
              this.$message({  message: res.data.message, type: "error", });
            }
        });
    },

    handleInput(value) {
      this.roadFillingInput = value.replace(/[^\d.]/g,'')
    },
    handleclick2(){
      this.dialogdeleteCause = false
      this.deleteCause = ''
    },
    btnNameStu (row) {
      this.popupVisible = false
      this.$nextTick(() => {
        this.popupVisible = true
        this.stuNameId = row.id
      })
    },
    batchtecherBtnList (val) {
      if (val) {
        let params = {
          courseDate: this.batchList.courseDate,
          courseTimeOn: this.batchList.courseTimeOn,
          courseEndTime: this.batchList.courseEndTime,
          categoryId: this.batchList.courseId,
        }
        console.log(params);
        this.getteacherList(params)
      }
    },
    techerBtnList (val) {
      if (val) {
        console.log(this.courseScheduleData.courseDate);
        let params = {
          courseDate: this.courseScheduleData.courseDate,
          courseTimeOn: this.courseScheduleData.courseTimeOn,
          courseEndTime: this.courseScheduleData.courseEndTime,
          categoryId: this.batchList.courseId,
        }
        console.log(params);
        this.getteacherList(params)
      }
    },
    getteacherList (row) {
      axios
        .post(`${apiBaseUrl}/schedule/getTeacherList`, row,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
          console.log(res);
          this.teachers = res.data.data
        })
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    //返回按钮
    fanhui () {
      // this.$EventBus.$emit("delTreeNode",this.$route.query.initialView,"view");
      // this.$router.push('/classtasklist')
      this.$emit('childBtnClose', this.btnClickAllow)
    },
    //转换时间格式2023-10-13
    formatDate (dateTime) {
      return dateTime.split("T")[0];
    },
    //点击出现弹窗一键节课
    oneTouch () {
      this.$confirm('此操作将一键节课, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisibles = true
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消节课'
        });
      });
    },

    //一键节课保存
    okTouch () {
      let data = { courseDate: this.courseDate1 };
      console.log(this.courseDate1, '4555');
      axios
        .post(`${apiBaseUrl}/schedule/classEndingForAll`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res.data.code,'88');
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '结课成功'
            });
            this.openDialog()
            this.dialogVisibles = false
          } else {
            this.$message({
              type: 'error',
              message: '结课失败'
            });
            this.dialogVisibles = false
          }
        })
    },
    startTimeSelect (val, row) {
      if (val == "start") {
        this.courseScheduleData.courseTimeOn = row
      } else if (val == "end") {
        this.courseScheduleData.courseEndTime = row
      } else if (val == "start1") {
        this.batchList.courseTimeOn = row
      } else if (val == "end1") {
        this.batchList.courseEndTime = row
      }
    },
    //返回按钮
    goBack () {
      this.$router.back(-1);
    },
    handleChange () { },
    handleClick () { },
    //选中学员事件
    handleSelectionChange (arr) {
      // console.log(arr,'kkkkknnnnnnnnnnnn');
      const aa = [];
      for (let i = 0; i < arr.length; i++) {
        aa.push(arr[i].id);
      }
      this.selectedStudents = aa;
    },
    //单个查询排课接口
    openDialog () {
      this.courseScheduleData.scheduleId = this.childScheduleId; //路由携带过来的scheduleId
      axios
        .post(`${apiBaseUrl}/preScheduled/selectscheduleone`, {
          scheduleId: this.courseScheduleData.scheduleId,
          realname: this.name
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })

        .then(response => {
          const list = response.data.data.list;


          // 将回显的排课信息数据保存到组件的属性中
          this.batchList.batchNo = list.batchNo;
          this.batchList.selectDate = list.courseDate;
          this.batchList.scheduleId = list.scheduleId;
          this.batchList.checkList = (list.recurrentScheduling + "").split("");
          this.batchList.courseId = list.courseId;
          this.batchList.numberOfClassDeductions = list.numberOfClassDeductions;
          this.courseDate1 = list.courseDate

          this.isShow = list.isPreScheduled === 0 ? true : false
          // this.isShow1 = list.courseStatus === 2 ? true : false

          if( list.courseStatus === 2 && list.isPreScheduled === 1){
              this.isShow1 = true
          }else{
              this.isShow1 = false
          }

          this.typeState = list.classPersonType === 1 ? '孩子' : list.classPersonType === 2 ? '孩子和父亲' : list.classPersonType === 3 ? '孩子和母亲' : list.classPersonType === 4 ? '父亲' : list.classPersonType === 5 ? '母亲' : list.classPersonType === 6 ? '父亲和母亲' : list.classPersonType === 7 ? '孩子、父亲、母亲' : ''

          // this.classPersonType = list.classPersonType
          // this.classPersonType1 = list.classPersonType

          this.typeState1 = list.productClassType  === 1 ? '1v1' : list.productClassType  === 2 ? '1v2' :  list.productClassType  === 3 ? '1v3' : ''

          this.courseStatus =  list.courseStatus === 1 ?  '实际排课'  :  '预排课'
          this.isPreScheduled =  list.isPreScheduled === 1 ?  '未同步'  :  '已同步'


          this.scheduleIdIDS = list.scheduleId
          this.isAudition = list.isAudition 

          // (this.batchList.recurrentScheduling = list.recurrentScheduling);

          this.courseScheduleData = list;

          if(list.roadSupplement){
             this.roadFillingInput = list.roadSupplement
             this.roadFilling = 1
          }else{
            this.roadFilling = 2
          }
          // this.courseScheduleData.courseName = list.courseName;
          // this.courseScheduleData.scheduleId = list.scheduleId;
          // this.courseScheduleData.teacherId = list.teacherId;
          // this.courseScheduleData.courseDate = list.courseDate;
          // this.courseScheduleData.courseTimeOn = list.courseTimeOn;
          // this.courseScheduleData.courseEndTime = list.courseEndTime;
          // this.courseScheduleData.teacherName = list.teacherName;
          // this.courseScheduleData.classEnding = list.classEnding;

          // this.courseScheduleData.courseName= {
          //   courseName: list.courseName,
          //   scheduleId: list.scheduleId,
          //   teacherId: list.teacherId,
          //   courseDate: list.courseDate,
          //   courseTimeOn: list.courseTimeOn,
          //   courseEndTime: list.courseEndTime,
          //   teacherName:list.teacherName
          //   // studentId:(list.studentList && list.studentList.map(student => student.id).toString()) || ''
          // };
          list.studentList.forEach((itmes)=>{
              if(itmes.prepareAddress ){
                itmes.prepareAddress  =  JSON.parse(itmes.prepareAddress)
              }
          }); 

          this.studentList = list.studentList;



          
          (this.batchList.courseTimeOn = list.courseTimeOn),
            (this.batchList.courseEndTime = list.courseEndTime);
          this.batchList.courseDate = list.courseDate;
          this.batchList.teacherId = list.teacherId;
          for (var i = 0; i < list.studentList.length; i++) {
            this.batchList.studentIdd.push(list.studentList[i].id);
          }
          this.batchList.educationType = list.educationType;
          this.batchList.relativeTime = list.relativeTime + "";
          // this.bachList.checkList = list.numberOfClassDeductions;
          this.batchList.num = list.num;
          this.batchList.scheduleId = list.scheduleId;
          this.batchList.batchNo = list.batchNo;


          this.ClassType = list.productClassType
          this.classPersonType = list.classPersonType
          this.classPersonType1 = list.classPersonType

          if(this.ClassType === 1){
             this.classPersonTypeList = [{id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'}, ]
          }
          else if(this.ClassType === 2){
             this.classPersonTypeList = [{id:2,name:'孩子和父亲'}, {id:3,name:'孩子和母亲'}, {id:6,name:'父亲和母亲'},]
          }
          else if(this.ClassType === 3){
             this.classPersonTypeList = [ {id:7,name:'孩子、父亲、母亲'} ]
          }else{
            this.classPersonType  = ''
          }




          axios.post(`${apiBaseUrl}/preScheduled/getClassType`, { categoryId: list.categoryId, studentId:  '[' + this.batchList.studentIdd + ']' },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
            let data = res.data.data
            if(data.length > 0){
                data.forEach((itme)=>{
                  itme.id = itme.classType
                  itme.name = itme.classType === 1 ? '1v1' : itme.classType === 2 ? '1v2' : '1v3'
                })
                this.classPersonTypeList1 = data

            }else{
                this.classPersonTypeList1 =[]
            }
          })


         if (this.$refs.multipleTable) {
              this.$refs.multipleTable.reloadData();
          }

          
        })
        

        .catch(error => {
          console.log(error);
        });

      this.dialogVisible = true;
    },
    closeDialog () {
      this.dialogVisible = false;
    },


    handleChanges(e){
        console.log(this.ClassType, 'this.ClassType')
        if(this.ClassType){
            if(this.ClassType === 1){
               this.classPersonTypeList = [{id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'}, ]
            }
            if(this.ClassType === 2){
               this.classPersonTypeList = [{id:2,name:'孩子和父亲'}, {id:3,name:'孩子和母亲'}, {id:6,name:'父亲和母亲'},]
            }
            if(this.ClassType === 3){
               this.classPersonTypeList = [ {id:7,name:'孩子、父亲、母亲'} ]
            }
        }else{
          this.classPersonTypeList = []
          // this.$message({ message:'请选择班型~' , type:'warning' })
        }
    },

    saveEditForm () { },
    //按回车搜索姓名查询
    handleSearch () {
      // if (this.name) {
      //   // console.log("搜索姓名：", this.name);
      //   this.openDialog();
      //   // 清空搜索框
      //   // this.name = "";
      // }
      this.openDialog();
    },
    inputListener () {
      this.openDialog();
    },
    //点击结课按钮
    endCourse () {
      const data = {
        scheduleId: parseInt(this.childScheduleId),
        classEnding: 1
      };
      axios
        .put(`${apiBaseUrl}/schedule/classending`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          if (response.data.code === 200) {
            // 学员已全部签到，可以结课
            // this.$message.success("操作成功！");
            this.openDialog()
            this.courseScheduleData.classEnding = 1;
            this.$emit("handleEventEmit")
          }
        })

        .catch(error => {
          console.log(error);
          this.$message.error(error);
        });
    },
    //取消结课
    cancelEndCourse () {
      const data = {
        scheduleId: parseInt(this.childScheduleId),
        classEnding: 2
      };
      axios
        .put(`${apiBaseUrl}/schedule/classending`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          if (response.data.code === 200) {
            // 学员已全部签到，可以结课
            // this.$message.success("操作成功！");
            this.openDialog()
            this.courseScheduleData.classEnding = 2;
            this.$emit("handleEventEmit")
          }
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    //点击修改课节弹层
    cancelCourse () {
      this.showDialog = true;
    },
    //查询教师列表
    fetchTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.teachers = response.data.data; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },
    //修改课节保存逻辑
    submitForm1 () {
      loadingUtils.startLoading();
      // this.$refs.ruleForm.validate(valid => {
      //   if (valid) {
          // update
          const data = {
            categoryId: this.courseScheduleData.categoryId,
            scheduleId: this.courseScheduleData.scheduleId,
            teacherId: this.courseScheduleData.teacherId,
            courseDate: this.courseScheduleData.courseDate,
            courseTimeOn: this.courseScheduleData.courseTimeOn,
            courseEndTime: this.courseScheduleData.courseEndTime,
            teacherName: this.courseScheduleData.teacherName,
            educationType: this.courseScheduleData.educationType,
            isFirst: this.courseScheduleData.isFirst,
            isFive: this.courseScheduleData.isFive,
            roadSupplement: this.roadFillingInput,
            updateCause:this.updateCause1,
            classPersonType:this.classPersonType1,
            productClassType: this.ClassType,
            studentId: this.batchList.studentIdd.join(",")
          };
          axios.put(`${apiBaseUrl}/preScheduled/updateschedule`, data,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
              response.data.code == 200 ? this.$message({ message:response.data.msg,  type: "success" }) : this.$message({ message:response.data.msg,  type: "error" });
              loadingUtils.endLoading();
              this.openDialog();
              this.showDialog = false;
              this.btnClickAllow = true;
              this.updateCause1 = ''
              this.roadFilling = 2
              this.roadFillingInput = ""
              this.showTTT = false
              this.classPersonType1 = ''
              this.ClassType = ''
            }).catch(error => {
              loadingUtils.endLoading();
              console.log(error);
            });
        // } else {
          // 表单校验不通过
          loadingUtils.endLoading();
          // return false;
        // }
      // });
    },

    //签到按钮
    saveSignin (type) {
      if (type === 1) {
        //如果为1弹签到弹窗
        this.dialog = true;
      } else {
        //否则弹提交弹窗
        if (!this.selectedStudents.length) {
          this.$message.warning("请选择学员");
        } else {
          if (this.signin !== 1) {
            this.$message.warning("请签到");
            return;
          }

          const requestBody = {
            // 将传的排课id字符串用parseInt转换为数字
            scheduleId: parseInt(this.childScheduleId),
            studentId: this.selectedStudents.join(",")
            // signin: this.signin
          };
          axios
            .put(`${apiBaseUrl}/schedule/signin`, requestBody,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
            .then(response => {
              console.log(response.data.data);
              if (response.data.code === 200) {
                this.$message.success("签到成功");
                this.dialog = false;
                // 更新列表数据
                this.openDialog();
              } else {
                this.$message.error("签到失败");
              }
            })
            .catch(error => {
              console.log(error);
            });
          this.dialog = false;
        }
      }
    },
    //点击姓名出现弹层
    highlightRow (index) {
      // 清除之前的高亮状态
      if (this.highlightedIndex !== -1) {
        // 假设表格组件提供了清除高亮的方法，如 clearHighlight
        this.$refs.table.clearHighlight();
      }
      // 设置当前行为高亮状态
      // 假设表格组件提供了设置高亮的方法，如 highlightRow
      this.$refs.table.highlightRow(index);
      this.highlightedIndex = index;
    },
    //删除课节
    delClass () {
      this.$confirm("此操作将永久删除该课节, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dialogdeleteCause = true
        this.type = 1
        // axios
        //   .delete(`${apiBaseUrl}/schedule/delete/${this.batchList.scheduleId}/${this.deleteCause}`)
        //   .then(res => {
        //     if (res.data.code == 200) {
        //       this.$message.success(res.data.message);
        //       this.$emit('childBtnRefresh')
        //     } else {
        //       this.$message.error(res.data.message);
        //     }
        //   })
        //   .catch(error => {
        //     console.error(error);
        //   });
      });
    },
    submitForm222(){
      if(this.ClassType){
        this.showTT = true
      }else{
        this.$message({ message:'请选择班型', type:'warning' })
      }
    },
    submitForm333(){
      if(this.ClassType){
        this.showTTT = true
      }else{
        this.$message({ message:'请选择班型', type:'warning' })
      }
    },
    handleclick1(){
      let admin = {}
      if(localStorage.getItem('admin')){
          admin = JSON.parse(localStorage.getItem('admin'))
      }

      if(this.type === 1 ){
        if(this.deleteCause){
            let data = { deleteCause: this.deleteCause, delPersonId: admin.id }
          axios.post(`${apiBaseUrl}/preScheduled/delete/${this.batchList.scheduleId}`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }).then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.dialogdeleteCause = false
                this.deleteCause = ''
                this.$emit('childBtnRefresh')
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.error(error);
            });
        }else{
          this.$message({ message: '请输入删除原因', type: "warning" });
        }
      }
      if(this.type === 2 ){
         if(this.deleteCause){
          let data = { deleteCause: this.deleteCause, delPersonId: admin.id }
          axios.post(
              `${apiBaseUrl}/preScheduled/deleteScheduleByBatchNo/${this.batchList.selectDate}/${this.batchList.batchNo}`,data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(res => {
              console.log(res, 'deleteScheduleByBatchNo')
              if (res.data.code == 200) {
                this.$message.success("删除成功");
                this.dialogdeleteCause = false
                this.deleteCause = ''
                // this.$EventBus.$emit("delTreeNode");
                // this.$router.back(-1);
                this.$emit('childBtnRefresh')
              }
              if(res.data.code === 500){
                this.$message({
                  message: res.data.msg,
                  type: "info"
                });
              }

            }).catch(() => {
            this.$message({
              type: "info",
              message: "删除视频"
            });
        });
         }else{
          this.$message({ message: '请输入删除原因', type: "warning" });
         }
      }
    },
    //批量删除
    batchDels () {
      this.$confirm(
        "批量删除会删除本循环排课的整批次课节,但是本时间点以前的课节(已过期课节)不被删除,确定删除?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.dialogdeleteCause = true
          this.type = 2
          // axios.post(
          //     `${apiBaseUrl}/schedule/deleteScheduleByBatchNo/${this.batchList.selectDate}/${this.batchList.batchNo}/${this.deleteCause}`
          //   )
          //   .then(res => {
          //     if (res.data.code == 200) {
          //       this.$message.success("删除成功");
          //       // this.$EventBus.$emit("delTreeNode");
          //       // this.$router.back(-1);
          //       this.$emit('childBtnRefresh')
          //     }
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //刷新
    getList () {
      
      axios
        .post(`${apiBaseUrl}/preScheduled/selectscheduleone`, {
          id: this.id
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })

        .then(response => {
          const list = response.data.data.list;
          // 将回显的排课信息数据保存到组件的属性中
          this.batchList.batchNo = list.batchNo;
          this.batchList.selectDate = list.courseDate;
          this.batchList.scheduleId = list.scheduleId;
          this.batchList.checkList = (list.recurrentScheduling + "").split("");
          this.batchList.courseId = list.courseId;
          this.batchList.numberOfClassDeductions = list.numberOfClassDeductions;
          this.courseDate1 = list.courseDate
          this.courseScheduleData = list;

          if(list.roadSupplement){
             this.roadFillingInput = list.roadSupplement
             this.roadFilling = 1
          }else{
            this.roadFilling = 2
          }

          this.typeState = list.classPersonType === 1 ? '孩子' : list.classPersonType === 2 ? '孩子和父亲' : list.classPersonType === 3 ? '孩子和母亲' : list.classPersonType === 4 ? '父亲' : list.classPersonType === 5 ? '母亲' : list.classPersonType === 6 ? '父亲和母亲' : list.classPersonType === 7 ? '孩子、父亲、母亲' : ''

         // this.classPersonType = list.classPersonType
         // this.classPersonType1 = list.classPersonType

         this.typeState1 = list.productClassType  === 1 ? '1v1' : list.productClassType  === 2 ? '1v2' :  list.productClassType  === 3 ? '1v3' : ''

         this.courseStatus =  list.courseStatus === 1 ?  '实际排课'  :  '预排课'
         this.isPreScheduled =  list.isPreScheduled === 1 ?  '未同步'  :  '已同步'

         this.isAudition = list.isAudition 

         this.classPersonTypeList = [
              { id: 1, name: '孩子'},
              { id: 4, name: '父亲'},
              { id: 5, name: '母亲'},
              { id: 2, name: '孩子和父亲'},
              { id: 3, name: '孩子和母亲'},
              { id: 6, name: '父亲和母亲'},
              { id: 7, name: '孩子、父亲、母亲'},
          ]


          this.ClassType = list.productClassType
          this.classPersonType = list.classPersonType
          this.classPersonType1 = list.classPersonType

          list.studentList.forEach((itmes)=>{
              if(itmes.prepareAddress ){
                itmes.prepareAddress  =  JSON.parse(itmes.prepareAddress)
              }
          }); 

          this.studentList = list.studentList;


          if (this.$refs.multipleTable) {
              this.$refs.multipleTable.reloadData();
          }

          (this.batchList.courseTimeOn = list.courseTimeOn),
            (this.batchList.courseEndTime = list.courseEndTime);
          this.batchList.courseDate = list.courseDate;
          this.batchList.teacherId = list.teacherId;
          for (var i = 0; i < list.studentList.length; i++) {
            this.batchList.studentIdd.push(list.studentList[i].id);
          }
          this.batchList.educationType = list.educationType;
          this.batchList.relativeTime = list.relativeTime + "";
          // this.bachList.checkList = list.numberOfClassDeductions;
          this.batchList.num = list.num;
          this.batchList.scheduleId = list.scheduleId;
          this.batchList.batchNo = list.batchNo;
        })
        .catch(error => {
          console.log(error);
        });

      this.dialogVisible = true;
    },
    closeDialog () {
      this.dialogVisible = false;
    },
    //批量修改保存
    submitForm () {
      this.batchList.studentId = this.batchList.studentIdd.join(",");
      this.batchList.updateCause = this.updateCause
      this.batchList.classPersonType = this.classPersonType
      this.batchList.productClassType = this.ClassType


      axios.post(`${apiBaseUrl}/preScheduled/updateBatch`, this.batchList,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            this.id = res.data.data
            this.$message({   message: "修改成功",  type: "success" });
            this.getList()
            this.dialogVisible1 = false;
            this.btnClickAllow = true;
            this.showTT = false
            this.classPersonType = ''
            this.ClassType = ''
          } else {
            this.$message({ message: res.data.msg,  type: "error"  });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //批量修改
    batchChange () {
      this.$confirm(
        "批量修改会修改本循环排课的整批次课节,但是本时间点以前的课节(已过期课节)不被修改,确定进行批量修改?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {


          this.dialogVisible1 = true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    }
  }
};
</script>

<style scoped>
.body {
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  position: relative;
  text-align: center;
  /* position: fixed;
top: 80px;
width: 100%; */
  /* margin: auto; */
}

.header {
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  margin-top: 10px;
}

.sub {
  border: 1px solid #e1e1e1;
  height: 55px;
}

.footer {
  background-color: #fff;
  margin-top: 10px;
  height: 500px;
}

.courseClass {
  font-weight: 700;
  font-size: 20px;
}

.hr {
  margin-top: -7px;
}

.stu {
  margin-left: 10px;
  margin-right: 10px;
}

.detail {
  /* float: left;
  margin-left: 10px; */
  font-size: 28px;
  font-weight: 700;
}

.custom-dialog .el-dialog__header {
  text-align: left;
  /* 设置标题左对齐 */
}

.sign1 {
  color: green;
  font-weight: 600;
}

.sign2 {
  color: red;
  font-weight: 600;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 70% !important;
  }

  /* .pop{
    margin-left: -15% !important;
  } */
  #ff>>>.el-dialog {
    width: 70% !important;
  }

  #cc>>>.el-dialog {
    width: 75% !important;
  }
}

.name_color {
  color: #551a8b;
  cursor: pointer;
}

.icon_goback {
  color: #409eff;
  float: right;
  font-size: 30px
}

.course_post {
  float: left;
  margin-left: 20px;
}

.formLabel {
  font-size: 20px;
  font-weight: 700;
}

.form_text {
  font-size: 16px;
  font-weight: 700;
}
</style>
<style lang="less" scoped>
.stu_name {
  padding: 0;

  /deep/.el-dialog__body {
    padding-top: 0;
  }
}


// color: none;
</style>



// WEBPACK FOOTER //
// src/PreSchedule/ScheduleDetails.vue